import { useAuth } from '@praxis/component-auth'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { Button, Toolbar, Grid, IconButton } from '@material-ui/core'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'

const styles = makeStyles((theme) => ({
  root: {
    height: 56,
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      height: 48,
    },
    [theme.breakpoints.up('sm')]: {
      height: 64,
    },
    background: '#666',
    color: theme.palette.primary.contrastText,
  },
  loginButton: {
    color: theme.palette.primary.contrastText,
    margin: '0 auto',
  },
  topText: {
    overflow: 'hidden',
    flexShrink: 1,
    textOverflow: 'ellipsis',
  },
}))

const StyledToolbar = withStyles({
  gutters: {
    paddingLeft: 14,
    paddingRight: 4,
  },
})(Toolbar)

const Auth = (props) => {
  const auth = useAuth() // connect to the `AuthContext` provided by `App` above, using a React hook.
  const { isAuthorized, login, logout, session } = auth // assign variables of same name as properties off of `auth`
  const classes = styles(props)

  return (
    <>
      {/* 1 🎩 app bar */}
      <StyledToolbar className={classes.root}>
        {isAuthorized() ? ( //conditionally render either a login button or a welcome / logout.
          <>
            <Grid
              container
              wrap="nowrap"
              alignContent="center"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item className={classes.topText}>
                {session.userInfo.email}
              </Grid>
              <Grid item>
                <IconButton
                  aria-label="Sign Out"
                  color="inherit"
                  onClick={logout}
                >
                  <ExitToAppIcon />
                </IconButton>
              </Grid>
            </Grid>
          </>
        ) : (
          <Button size="medium" onClick={login} className={classes.loginButton}>
            SIGN IN
          </Button>
        )}
      </StyledToolbar>
    </>
  )
}

export default Auth

Auth.propTypes = {}
